import { menuAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
  defineStyleConfig,
} from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  // define the part you're going to style
  button: {
    // this will style the MenuButton component
    fontWeight: 'medium',
    bg: 'teal.500',
    color: 'gray.200',
    _hover: {
      bg: 'teal.600',
      color: 'white',
    },
  },
  list: {
    // this will style the MenuList component
    py: '4',
    borderRadius: 'xl',
    border: 'none',
    bg: 'teal.500',
  },
  item: {
    // this will style the MenuItem and MenuItemOption components
    color: 'gray.200',
    _hover: {
      bg: 'teal.600',
    },
    _focus: {
      bg: 'teal.600',
    },
  },
  groupTitle: {
    // this will style the text defined by the title prop
    // in the MenuGroup and MenuOptionGroup components
    textTransform: 'uppercase',
    color: 'white',
    textAlign: 'center',
    letterSpacing: 'wider',
    opacity: '0.7',
  },
  command: {
    // this will style the text defined by the command
    // prop in the MenuItem and MenuItemOption components
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    pl: '4',
  },
  divider: {
    // this will style the MenuDivider component
    my: '4',
    borderColor: 'white',
    borderBottom: '2px dotted',
  },
});

const selectStyle = definePartsStyle({
  button: {
    color: 'dark.default',
    fontSize: '14px',
    fontWeight: 400,
    borderRadius: '5px',
    bg: 'dark.default',
    _hover: {
      bg: 'dark.default',
      color: 'white',
    },
  },
  list: {
    bg: '#f6f6f6',
    py: '1',
    border: 'none',
  },
  item: {
    height: '30px',
    bg: '#f6f6f6',
    color: 'info.default',
    _hover: {
      bg: 'info.default',
      color: '#FFF',
    },
    _focus: {
      bg: 'info.default',
      color: '#FFF',
    },
  },
  groupTitle: {
    bg: 'info.default',
    textTransform: 'uppercase',
    color: 'info.default',
    textAlign: 'center',
    letterSpacing: 'wider',
    opacity: '0.7',
  },
  command: {
    bg: 'info.default',
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    pl: '4',
  },
  divider: {
    my: '1',
    bg: 'info.default',
    borderColor: 'white',
    borderBottom: '2px dotted',
  },
});

const checkStyle = definePartsStyle({
  button: {
    color: 'dark.default',
    fontSize: '14px',
    fontWeight: 400,
    borderRadius: '5px',
    bg: 'dark.default',
    _hover: {
      bg: 'dark.default',
      color: 'white',
    },
  },
  list: {
    bg: '#f6f6f6',
    py: '1',
    border: 'none',
  },
  item: {
    height: '30px',
    bg: '#f6f6f6',
    color: 'info.default',
    _hover: {
      bg: 'info.default',
      color: '#FFF',
    },
    _focus: {
      bg: 'info.default',
      color: '#FFF',
    },
  },
  groupTitle: {
    bg: 'info.default',
    textTransform: 'uppercase',
    color: 'info.default',
    textAlign: 'center',
    letterSpacing: 'wider',
    opacity: '0.7',
  },
  command: {
    bg: 'info.default',
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    pl: '4',
  },
  divider: {
    my: '1',
    bg: 'info.default',
    borderColor: 'white',
    borderBottom: '2px dotted',
  },
});

// export the base styles in the component theme
// export const menuTheme = defineMultiStyleConfig({ baseStyle });

export const menuTheme = defineStyleConfig({
  variants: { baseStyle, selectStyle, checkStyle },
});
